export class MiCoveragePercentageCriteriaApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getCriteria(params) {
    return this.#http.get('/api/mi-coverage-percentage-criteria', { params });
  }

  async createCriteria(body) {
    return this.#http.post('/api/mi-coverage-percentage-criteria', body);
  }

  async editCriteria({ criteriaId, ...body }) {
    return this.#http.put(`/api/mi-coverage-percentage-criteria/${criteriaId}`, body);
  }

  async deleteCriteria({ criteriaId }) {
    return this.#http.delete(`/api/mi-coverage-percentage-criteria/${criteriaId}`);
  }
}
